import { Link } from "react-router-dom";
import { formatViews, topByViews } from "@/lib/media";

export default function RankingSection() {
  const panels = [
    {
      title: "热门电影榜",
      to: "/movies",
      kind: "movie" as const,
      items: topByViews("movie", 5),
    },
    {
      title: "热门电视剧榜",
      to: "/tvshows",
      kind: "tv" as const,
      items: topByViews("tv", 5),
    },
  ];

  return (
    <section className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热门影片榜单
          </h2>
          <p className="mt-1.5 text-sm text-foreground-500">
            根据近期观看与关注热度实时整理，大家都在看这些
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
        {panels.map((panel) => (
          <div
            key={panel.title}
            className="rounded-lg border border-background-200/60 bg-background-100/50 p-4 md:p-5"
          >
            <div className="mb-3 flex items-center justify-between">
              <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-900">
                <i
                  className={`${
                    panel.kind === "movie" ? "ri-fire-fill text-primary-500" : "ri-flashlight-fill text-accent-500"
                  }`}
                ></i>
                {panel.title}
              </h3>
              <Link
                to={panel.to}
                className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-500 hover:text-primary-500"
              >
                全部
                <i className="ri-arrow-right-s-line"></i>
              </Link>
            </div>

            <ol className="space-y-1">
              {panel.items.map((item, i) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    className="group flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-200/50"
                  >
                    <span
                      className={`w-6 shrink-0 text-center font-heading text-lg font-bold ${
                        i < 3 ? "text-primary-500" : "text-foreground-400"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md">
                      <img
                        src={item.poster}
                        alt={`${item.title} 海报`}
                        title={`${item.title} 在线观看`}
                        className="h-full w-full object-cover object-top"
                      />
                    </div>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-500">
                        {item.title}
                      </p>
                      <p className="mt-0.5 truncate text-xs text-foreground-500">
                        {item.genres.join(" · ")} · {item.year}
                      </p>
                    </div>
                    <div className="flex shrink-0 flex-col items-end">
                      <span className="flex items-center gap-1 text-sm font-semibold text-accent-400">
                        <i className="ri-star-fill text-[11px]"></i>
                        {item.rating.toFixed(1)}
                      </span>
                      <span className="mt-0.5 text-xs text-foreground-500">
                        {formatViews(item.views)}热度
                      </span>
                    </div>
                  </Link>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </section>
  );
}